import { Service } from '@/tools'
export class ordinaryBillOfLadingService<T extends TStock.ordinaryBillOfLading> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.ordinaryBillOfLading}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 功能：按订单放单列表
   */
  byOrder = (data: T['ApiByOrder']['req']): Promise<T['ApiByOrder']['res']> => this.post2('v1/ApiByOrder', data)

  /**
   * 功能：根据订单查询商品信息
   */
  orderProducts = (data: T['ApiOrderProducts']['req']): Promise<T['ApiOrderProducts']['res']> => this.post2('v1/ApiOrderProducts', data)

  /**
   * 功能：按客户放单列表
   */
  byCustomer = (data: T['ApiByCustomer']['req']): Promise<T['ApiByCustomer']['res']> => this.post2('v1/ApiByCustomer', data)

  /**
   * 功能：按客户查询订单商品列表
   */
  customerOrders = (data: T['ApiCustomerOrders']['req']): Promise<T['ApiCustomerOrders']['res']> => this.post2('v1/ApiCustomerOrders', data)

  /**
   * 功能：按品种放单列表
   */
  byVariety = (data: T['ApiByVariety']['req']): Promise<T['ApiByVariety']['res']> => this.post2('v1/ApiByVariety', data)

  /**
   * 功能：按品种查询订单商品列表
   */
  skuProducts = (data: T['ApiSkuProducts']['req']): Promise<T['ApiSkuProducts']['res']> => this.post2('v1/ApiSkuProducts', data)

  /**
   * 功能：按库存订单放单列表
   */
  byStock = (data: T['ApiByStock']['req']): Promise<T['ApiByStock']['res']> => this.post2('v1/ApiByStock', data)

  /**
   * 功能：按库存查询订单商品列表
   */
  stockProducts = (data: T['ApiStockProducts']['req']): Promise<T['ApiStockProducts']['res']> => this.post2('v1/ApiStockProducts', data)

  /**
   * 功能：普通放单
   */
  releaseOrders = (data: T['ApiReleaseOrders']['req']): Promise<T['ApiReleaseOrders']['res']> => this.post2('v1/ApiReleaseOrders', data, '放单成功')

  /**
   * 功能：查询sku批次列表
   */
  querySkuBatch = (data: T['ApiQuerySkuBatch']['req']): Promise<T['ApiQuerySkuBatch']['res']> => this.post2('v1/ApiQuerySkuBatch', data)

  /**
   * 功能：中小学-按订单-明细
   */
  queryOrderDetailBySchools = (data: T['ApiQueryOrderDetailBySchools']['req']): Promise<T['ApiQueryOrderDetailBySchools']['res']> =>
    this.post2('v1/ApiQueryOrderDetailBySchools', data)
  /**
   * 功能：中小学-按客户-明细
   */
  queryCustomerDetailBySchools = (data: T['ApiQueryCustomerDetailBySchools']['req']): Promise<T['ApiQueryCustomerDetailBySchools']['res']> =>
    this.post2('v1/ApiQueryCustomerDetailBySchools', data)

  /**
   * 功能：中小学-按品种-明细
   */
  queryProductDetailBySchools = (data: T['ApiQueryProductDetailBySchools']['req']): Promise<T['ApiQueryProductDetailBySchools']['res']> =>
    this.post2('v1/ApiQueryProductDetailBySchools', data)

  /**
   * 功能：中小学-按库存-明细
   */
  queryOrderDetailStockBySchools = (data: T['ApiQueryOrderDetailStockBySchools']['req']): Promise<T['ApiQueryOrderDetailStockBySchools']['res']> =>
    this.post2('v1/ApiQueryOrderDetailStockBySchools', data)

  /**
   * 库存释放
   * /api/order/release/v1/releaseStock
   */
  releaseStock = (data: T['ApiReleaseStock']['req']): Promise<T['ApiReleaseStock']['res']> => this.post2('v1/ApiReleaseStock', data)

  /**
   * 指定批次释放
   * /api/order/release/v1/releaseBatchStock
   */
  releaseBatchStock = (data: T['ApiReleaseBatchStock']['req']): Promise<T['ApiReleaseBatchStock']['res']> =>
    this.post2('v1/ApiReleaseBatchStock', data)

  /**
   * 普通占用
   * /api/order/release/v1/occupy
   */
  occupy = (data: T['ApiOccupy']['req']): Promise<T['ApiOccupy']['res']> => this.post2('v1/ApiOccupy', data)
  /**
   * 指定批次占用
   * /api/order/release/v1/occupyBatchStock
   */
  occupyBatchStock = (data: T['ApiOccupyBatchStock']['req']): Promise<T['ApiOccupyBatchStock']['res']> => this.post2('v1/ApiOccupyBatchStock', data)
  /**
   * 功能：即进即发明细列表
   */
  instantInAndOutList = (data: T['ApiInstantInAndOutList']['req']): Promise<T['ApiInstantInAndOutList']['res']> =>
    this.post2('v1/ApiInstantInAndOutList', data)
  /**
   *
   * @param 占用列表和释放列表
   * @returns/api/order/release/v1/stockOccupyReleaseList
   */
  stockOccupyReleaseList = (data: T['ApiStockOccupyReleaseList']['req']): Promise<T['ApiStockOccupyReleaseList']['res']> =>
    this.post2('v1/ApiStockOccupyReleaseList', data)
}
